import { SHIPPER_GUIDE_API_URL } from 'core/infra/environment'
import { HttpClient, createTokenInterceptor } from 'core/infra/http/HttpClient'
import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { MagicLinkUserRepository } from './MagicLinkUserRepository'

export function createMagicLinkHttpClient() {
  const storage = new LocalStorageClient()
  const userRepository = new MagicLinkUserRepository({ storage })
  const httpClient = new HttpClient(SHIPPER_GUIDE_API_URL, {
    requestInterceptor: createTokenInterceptor({ userRepository }),
    responseInterceptor: null,
  })

  return httpClient
}
